/**
 * Meliusly Ajax cart — open/close drawer, add/change lines, re-render the
 * drawer via the Section Rendering API so Liquid stays the single source
 * of markup. Mirrors the headless cart drawer behavior.
 */
(function () {
  var SECTION_ID = 'meliusly-cart-drawer';
  var isOpen = false;

  function root() { return document.querySelector('[data-mel-cart-root]'); }
  function overlay() { return document.querySelector('[data-mel-cart-overlay]'); }
  function panel() { return document.querySelector('[data-mel-cart-panel]'); }

  function setOpen(open) {
    isOpen = open;
    var o = overlay();
    var p = panel();
    if (!o || !p) return;
    if (open) {
      o.classList.remove('pointer-events-none', 'opacity-0');
      o.classList.add('opacity-100');
      p.classList.remove('pointer-events-none', 'translate-x-full');
      p.classList.add('translate-x-0');
      p.setAttribute('aria-modal', 'true');
      document.body.style.overflow = 'hidden';
    } else {
      o.classList.add('pointer-events-none', 'opacity-0');
      o.classList.remove('opacity-100');
      p.classList.add('pointer-events-none', 'translate-x-full');
      p.classList.remove('translate-x-0');
      p.setAttribute('aria-modal', 'false');
      document.body.style.overflow = '';
    }
  }

  function bind() {
    var o = overlay();
    if (o) o.addEventListener('click', function () { setOpen(false); });
    Array.prototype.slice.call(document.querySelectorAll('[data-mel-cart-close]')).forEach(function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });
    Array.prototype.slice.call(document.querySelectorAll('[data-mel-cart-qty]')).forEach(function (el) {
      el.addEventListener('click', function () {
        var key = el.getAttribute('data-mel-cart-qty');
        var delta = parseInt(el.getAttribute('data-mel-qty-delta'), 10);
        var current = parseInt(el.getAttribute('data-mel-qty-current'), 10);
        var next = current + delta;
        if (next < 1) return;
        changeLine(key, next);
      });
    });
    Array.prototype.slice.call(document.querySelectorAll('[data-mel-cart-remove]')).forEach(function (el) {
      el.addEventListener('click', function () {
        changeLine(el.getAttribute('data-mel-cart-remove'), 0);
      });
    });
  }

  function updateHeaderCount(count) {
    Array.prototype.slice.call(document.querySelectorAll('[data-mel-cart-count]')).forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
    });
  }

  function rerender(sectionsHtml, itemCount) {
    var r = root();
    if (r && sectionsHtml) {
      var doc = new DOMParser().parseFromString(sectionsHtml, 'text/html');
      var fresh = doc.querySelector('[data-mel-cart-root]');
      if (fresh) {
        r.innerHTML = fresh.innerHTML;
        bind();
        if (isOpen) setOpen(true);
      }
    }
    if (typeof itemCount === 'number') updateHeaderCount(itemCount);
  }

  function refresh(then) {
    fetch(window.location.pathname + '?sections=' + SECTION_ID)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            rerender(data[SECTION_ID], cart.item_count);
            if (then) then();
          });
      })
      .catch(function () { if (then) then(); });
  }

  function changeLine(key, quantity) {
    fetch(((window.routes && window.routes.cart_change_url) || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: SECTION_ID })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        rerender(cart.sections && cart.sections[SECTION_ID], cart.item_count);
      })
      .catch(function () { refresh(); });
  }

  function addItem(variantId, quantity) {
    return fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1, sections: SECTION_ID })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        // /cart/add.js returns the line, not the cart — refresh for totals
        refresh(function () { setOpen(true); });
      });
  }

  // Public API used by product forms + header
  window.MeliuslyCart = {
    open: function () { setOpen(true); },
    close: function () { setOpen(false); },
    add: addItem,
    refresh: refresh
  };

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) setOpen(false);
  });

  Array.prototype.slice.call(document.querySelectorAll('[data-mel-cart-open]')).forEach(function (el) {
    el.addEventListener('click', function () { setOpen(true); });
  });

  bind();
})();
